import { render, staticRenderFns } from "./DiseaseApproveBySick.vue?vue&type=template&id=00ed3a08&scoped=true&"
import script from "./DiseaseApproveBySick.vue?vue&type=script&lang=js&"
export * from "./DiseaseApproveBySick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ed3a08",
  null
  
)

export default component.exports